<template>
  <div class="total-stat">
    <div class="total-stat-count" :live-dot="isLive">
      <span v-show="!isLoading">{{ value }}</span>
      <v-progress-circular
        v-show="isLoading"
        class="is-waiting-spinner"
        color="white"
        size="16"
        width="2"
        indeterminate
      />
    </div>
    <div v-once class="total-stat-description">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: 'EcsAgentKPICard',

  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isLive: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style src="./scoped.css" scoped></style>
